import { TrendingUp, TrendingDown } from "lucide-react";
import { fmtInt, deltaPct } from "../../data/ybf/utils";

export default function KPIScorecard({ icon: Icon, label, value, prev, unit, accent = "#00204E" }) {
  const d = deltaPct(value, prev);
  const isUp = d != null && d > 0;
  const isDown = d != null && d < 0;
  const formatted =
    unit?.includes("₹") ? `₹${value.toFixed ? value.toFixed(2) : value}` :
    unit === "%" ? `${value}%` :
    fmtInt(value);

  return (
    <div
      data-testid={`kpi-scorecard-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className="bg-white rounded-xl border border-slate-200 p-4 hover:shadow-md transition-shadow"
    >
      <div className="flex items-start justify-between">
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${accent}10`, color: accent }}
        >
          {Icon && <Icon size={18} />}
        </div>
        {d != null && (
          <span
            className={`inline-flex items-center gap-0.5 text-[10px] font-bold px-1.5 py-0.5 rounded-full ${
              isUp ? "bg-green-50 text-green-700" : isDown ? "bg-red-50 text-red-700" : "bg-slate-50 text-slate-500"
            }`}
          >
            {isUp ? <TrendingUp size={10} /> : isDown ? <TrendingDown size={10} /> : null}
            {isUp ? "+" : ""}{d.toFixed(0)}%
          </span>
        )}
      </div>
      <div className="mt-3">
        <div className="text-[10px] uppercase tracking-wider text-slate-500 font-medium">{label}</div>
        <div className="text-2xl font-bold text-slate-900 mt-0.5 leading-none">
          {formatted}
          {unit && !unit.includes("₹") && unit !== "%" && (
            <span className="text-xs text-slate-500 font-medium ml-1">{unit}</span>
          )}
          {unit?.includes("₹") && <span className="text-xs text-slate-500 font-medium ml-1">Cr</span>}
        </div>
      </div>
    </div>
  );
}
